$(function(){
  $(document).on('click', '.mobileMenuContainer a[href^="#"]', function(e) {
    // prevent standard hash navigation (avoid blinking in IE)
    e.preventDefault();
        $('.headerInner .buttonWrapper img').click();
 
    // target element id
    var id = $(this).attr('href');
  var parts = window.location.href.split('/');
    var part1_url=parts.pop();
	var part2_url=parts[parts.length - 1];
   
if(part1_url.indexOf('#') != -1 || part1_url ==''){

    // target element
    var $id = $(id);
    if ($id.length === 0) {
        return;
    }

    

    // top position relative to the document
    var pos = $id.offset().top - 100;

    // animated top scrolling
    $('body, html').animate({scrollTop: pos});
}else{
  location.href='https://'+window.location.hostname+'/'+id;
}
});

  if($('#programs_header').length){
   var mobileMenuContainer = document.getElementsByClassName("mobileMenuContainer")[0];
  var programs_header = document.getElementById("programs_header");
  mobileMenuContainer.append(programs_header);
  }
    
  
});